module.exports = __webpack_public_path__ + "static/media/1006001BE.4f3e715d.jpg";